<template>
  <div class="topfeature">
    <div class="renew3_wrapper">
      <ul class="flex topfeature_list">
        <li class="topfeature_item">
          <svg class="topfeature_icon" viewBox="0 0 48 48" aria-hidden="true">
            <circle cx="18" cy="16" r="7" />
            <path d="M5 41c0-7.2 5.8-13 13-13s13 5.8 13 13z" />
            <circle cx="34" cy="18" r="5.5" opacity="0.55" />
            <path
              d="M43 41c0-5.5-4-10-9-10.6"
              opacity="0.55"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
          <div class="topfeature_body">
            <p class="topfeature_label">利用実績</p>
            <p class="topfeature_main">
              <span class="topfeature_num">1,500</span>万人
            </p>
            <p class="topfeature_sub">突破！</p>
          </div>
        </li>
        <!-- 帯の中でここだけ緑ベタにして「5分で終わる」を主役にする -->
        <li class="topfeature_item topfeature_item_hero">
          <svg class="topfeature_ring" viewBox="0 0 52 52" aria-hidden="true">
            <circle class="topfeature_ring_track" cx="26" cy="26" r="22" />
            <circle class="topfeature_ring_fill" cx="26" cy="26" r="22" />
            <text
              class="topfeature_ring_text"
              x="26"
              y="31"
              text-anchor="middle"
            >
              5分
            </text>
          </svg>
          <div class="topfeature_body">
            <p class="topfeature_label">履歴書がたった</p>
            <p class="topfeature_main">5分で完成</p>
            <p class="topfeature_sub">スマホでもPCでもOK</p>
          </div>
        </li>
        <li class="topfeature_item topfeature_item_share">
          <!-- SP はテキストを置く余白が無いので、ブロック右上のリンクアイコンだけにする -->
          <a
            href="/mypage/yagiprime"
            class="topfeature_share_icon_btn"
            aria-label="ヤギプライム紹介割引をマイページで確認"
            @click="onCampaignLinkClick"
          >
            <!-- 円に「>」。押すと遷移することが分かる形にする -->
            <svg
              class="topfeature_share_icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M10.5 8.5 14 12l-3.5 3.5" />
            </svg>
          </a>
          <svg class="topfeature_icon" viewBox="0 0 48 48" aria-hidden="true">
            <rect
              x="6"
              y="18"
              width="36"
              height="24"
              rx="3"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
            />
            <path
              d="M4 18h40"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
            />
            <path
              d="M24 18v24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
            />
            <path
              d="M24 18c-6 0-9-2-9-5s4-4 6-2 3 7 3 7zm0 0c6 0 9-2 9-5s-4-4-6-2-3 7-3 7z"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linejoin="round"
            />
          </svg>
          <div class="topfeature_body">
            <!-- この帯は public/top-content.html へ静的抽出される（初回表示・SEO は
                 そのHTMLが出る）ので、文言は式ではなく直書きにする。式にすると
                 静的HTML側に {{ }} がそのまま残る -->
            <p class="topfeature_label">友だちにシェアで</p>
            <p class="topfeature_main">
              ヤギプライム<br class="topfeature_main_br" />紹介割引
            </p>
            <!-- PC はこのボタン、SP は右上のアイコンからマイページのキャンペーン枠
                 （紹介URL・紹介の状況）へ送る。未ログインでも出し、押したら
                 ログインページ経由でマイページへ戻す（静的HTMLでもリンクとして
                 動くよう出し分けの v-if は付けない） -->
            <a
              href="/mypage/yagiprime"
              class="topfeature_share_btn"
              @click="onCampaignLinkClick"
              >マイページで確認</a
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * トップのメインバナー下にある3カラム帯（実績・スピード・シェア）。
 *
 * Top.vue（1,700行超）の分解で切り出した。3つ目のカラムが紹介キャンペーンの入口。
 *
 * 見た目は @/assets/scss/top/feature-strip.scss に全部あるので、この SFC は
 * import するだけ。親から渡すものは無い。
 *
 * 3つ目のカラムは紹介キャンペーンの入口。PC はボタン、SP は右上の「円に >」
 * アイコンで、どちらもマイページのキャンペーン枠（紹介URL・紹介の状況）へ送る。
 * 共有そのものはマイページ側の枠でやってもらう。未ログインは /mypage が
 * requiresAuth で素の /login へ飛ばされ、ログイン後に /mypage トップへ落ちるので、
 * frompage 付きでログインページへ送ってキャンペーン枠へ戻す。
 *
 * **文言はテンプレートに直書きする。** この帯は `scripts/extract-top-static.js` が
 * public/top-content.html へ静的抽出し、初回表示と SEO はそのHTMLが使われるため、
 * computed や JSON から差し込むと静的HTML側に `{{ }}` が残ってしまう。
 * キャンペーンの文言カタログ（referralCampaign.json）はここでは使わない。
 */
import { useRouter } from 'vue-router/composables'
import { useAuth } from '@/composables/useAuth'

const { isAuthenticated } = useAuth()
const router = useRouter()

// トップにはログインダイアログが無いのでログインページへ送り、
// ログイン後にキャンペーン枠へ戻す（NewLogin.vue の frompage 分岐）
function onCampaignLinkClick(event: MouseEvent): void {
  if (isAuthenticated.value) return
  event.preventDefault()
  router.push({ path: '/login', query: { frompage: 'yagiprime_referral' } })
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/top/feature-strip';
</style>
